import { useQuery } from '@tanstack/react-query'

import { getAccountTopVisitors } from 'api/AccountActivityAPI'

export const useTopVisitors = (accountId: string) => {
  const { data } = useQuery({
    queryKey: ['getAccountTopVisitors', accountId],
    queryFn: () => getAccountTopVisitors(accountId).then(res => res ?? [])
  })

  if (!data) {
    return []
  }

  return data.data
}
